import { apiClient } from './client';

// ── Types ────────────────────────────────────────────────────────────
// Mirrors backend/schemas/forge_patterns.py. Keep in sync with the
// Pydantic envelope shape (session-1 commit bd7787e7).

export type PatternSeverity = 'routine' | 'notable' | 'significant' | 'critical';

export type PatternPromotable = 'investigation' | 'theatre';

export type ForgePatternMode = 'world';

export interface ProvenanceSignal {
  signal_id: string;
  source_group: string;
  label: string;
  observed_at: string;
}

export interface PatternProposal {
  pattern_id: string;
  fp_id: string;
  kind: string;
  severity: PatternSeverity;
  observed_at: string;
  prose: string;
  confidence: number;
  base_rate_correct: number;
  base_rate_total: number;
  promotable: PatternPromotable[];
  provenance: ProvenanceSignal[];
  source_group: string;
}

export interface ForgePatternsResponse {
  mode: ForgePatternMode;
  patterns: PatternProposal[];
  as_of: string;
  total: number;
}

// ── API ──────────────────────────────────────────────────────────────

export const forgeApi = {
  async getPatterns(
    mode: ForgePatternMode = 'world',
    limit = 40,
  ): Promise<ForgePatternsResponse> {
    const { data } = await apiClient.get('/api/v1/forge/patterns', {
      params: { mode, limit },
    });
    return data;
  },
};
